"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _Heading = _interopRequireDefault(require("../Heading"));
var _useVisibilityHook2 = _interopRequireDefault(require("../useVisibilityHook"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Wysiwyg = function Wysiwyg(props) {
  var content = props.content,
    language = props.language;
  var _useVisibilityHook = (0, _useVisibilityHook2["default"])(props),
    isVisible = _useVisibilityHook.isVisible;
  if (!isVisible) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  var header = '';
  if (language === 'en' && 'headingEn' in content) {
    header = content.headingEn;
  } else if (language === 'es' && 'headingEs' in content) {
    header = content.headingEs;
  }
  var body = '';
  if (language === 'en' && 'contentEn' in content) {
    body = content.contentEn;
  } else if (language === 'es' && 'contentEs' in content) {
    body = content.contentEs;
  }
  if (!header && !body) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, header && /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    text: header
  }), body && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: body
  })));
};
var _default = exports["default"] = Wysiwyg;